"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphFrameHorizontalPositionType = exports.ParagraphFrameHorizontalPositionAlignment = exports.ParagraphFrameVerticalPositionAlignment = exports.ParagraphFrameHorizontalRule = exports.ParagraphFrameFormattingInfo = void 0;
var ParagraphFrameFormattingInfo = (function () {
    function ParagraphFrameFormattingInfo() {
    }
    ParagraphFrameFormattingInfo.createDefaultInfo = function () {
        return new ParagraphFrameFormattingInfo();
    };
    ParagraphFrameFormattingInfo.prototype.clone = function () {
        return new ParagraphFrameFormattingInfo();
    };
    return ParagraphFrameFormattingInfo;
}());
exports.ParagraphFrameFormattingInfo = ParagraphFrameFormattingInfo;
var ParagraphFrameHorizontalRule;
(function (ParagraphFrameHorizontalRule) {
    ParagraphFrameHorizontalRule[ParagraphFrameHorizontalRule["Auto"] = 0] = "Auto";
    ParagraphFrameHorizontalRule[ParagraphFrameHorizontalRule["AtLeast"] = 1] = "AtLeast";
    ParagraphFrameHorizontalRule[ParagraphFrameHorizontalRule["Exact"] = 2] = "Exact";
})(ParagraphFrameHorizontalRule = exports.ParagraphFrameHorizontalRule || (exports.ParagraphFrameHorizontalRule = {}));
var ParagraphFrameVerticalPositionAlignment;
(function (ParagraphFrameVerticalPositionAlignment) {
    ParagraphFrameVerticalPositionAlignment[ParagraphFrameVerticalPositionAlignment["Inline"] = 0] = "Inline";
    ParagraphFrameVerticalPositionAlignment[ParagraphFrameVerticalPositionAlignment["Center"] = 1] = "Center";
    ParagraphFrameVerticalPositionAlignment[ParagraphFrameVerticalPositionAlignment["Bottom"] = 2] = "Bottom";
    ParagraphFrameVerticalPositionAlignment[ParagraphFrameVerticalPositionAlignment["Top"] = 3] = "Top";
    ParagraphFrameVerticalPositionAlignment[ParagraphFrameVerticalPositionAlignment["Inside"] = 4] = "Inside";
    ParagraphFrameVerticalPositionAlignment[ParagraphFrameVerticalPositionAlignment["Outside"] = 5] = "Outside";
    ParagraphFrameVerticalPositionAlignment[ParagraphFrameVerticalPositionAlignment["None"] = 6] = "None";
})(ParagraphFrameVerticalPositionAlignment = exports.ParagraphFrameVerticalPositionAlignment || (exports.ParagraphFrameVerticalPositionAlignment = {}));
var ParagraphFrameHorizontalPositionAlignment;
(function (ParagraphFrameHorizontalPositionAlignment) {
    ParagraphFrameHorizontalPositionAlignment[ParagraphFrameHorizontalPositionAlignment["Left"] = 0] = "Left";
    ParagraphFrameHorizontalPositionAlignment[ParagraphFrameHorizontalPositionAlignment["Center"] = 1] = "Center";
    ParagraphFrameHorizontalPositionAlignment[ParagraphFrameHorizontalPositionAlignment["Right"] = 2] = "Right";
    ParagraphFrameHorizontalPositionAlignment[ParagraphFrameHorizontalPositionAlignment["Inside"] = 3] = "Inside";
    ParagraphFrameHorizontalPositionAlignment[ParagraphFrameHorizontalPositionAlignment["Outside"] = 4] = "Outside";
    ParagraphFrameHorizontalPositionAlignment[ParagraphFrameHorizontalPositionAlignment["None"] = 5] = "None";
})(ParagraphFrameHorizontalPositionAlignment = exports.ParagraphFrameHorizontalPositionAlignment || (exports.ParagraphFrameHorizontalPositionAlignment = {}));
var ParagraphFrameHorizontalPositionType;
(function (ParagraphFrameHorizontalPositionType) {
    ParagraphFrameHorizontalPositionType[ParagraphFrameHorizontalPositionType["Page"] = 0] = "Page";
    ParagraphFrameHorizontalPositionType[ParagraphFrameHorizontalPositionType["Column"] = 1] = "Column";
    ParagraphFrameHorizontalPositionType[ParagraphFrameHorizontalPositionType["Margin"] = 2] = "Margin";
})(ParagraphFrameHorizontalPositionType = exports.ParagraphFrameHorizontalPositionType || (exports.ParagraphFrameHorizontalPositionType = {}));
